import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { UUID } from "angular2-uuid";
import { AProgessBarWizardComponent } from '../../components/common/progressbarwizard/iprogressbar.wizard.component';
import { DataModelService, DataSourceQuery } from "../../services/datamodel.service";
import { IntegrationService } from "../../services/integration.service";

@Component({
    selector: 'iw-migration-page',
    templateUrl: './iw.migration.page.html',
    styleUrls: ['./iw.migration.page.css']
})
export class IntegrationWizardMigrationPage extends AProgessBarWizardComponent implements OnInit {
    FileName = '';
    DataModels = [];
    DataSources = [];
    TargetTables = [];
    TargetValues = [];

    constructor(private cdRef: ChangeDetectorRef, private service: IntegrationService, private dmService: DataModelService) {
        super();
    }

    ngOnInit(): void {
        this.dmService.GetModels().subscribe((result) => {
            this.DataModels = result;
            if (!this.WizardState.DataModel && result && result.length == 1) {
                this.WizardState.DataModel = result[0];
            }
            if (this.WizardState.DataModel) {
                const query = new DataSourceQuery(this.WizardState.DataModel.SID);
                query.DBUsages = [[8192]];
                query.IgnoreResourceBase = true;
                this.dmService.GetDataSourcesByQuery(query).subscribe(x => {
                    if (x) {
                        this.DataSources = x;
                        if (!this.WizardState.DataSource && x && x.length == 1) {
                            this.WizardState.DataSource = x[0];
                        }
                        if (this.WizardState.DataSource) {
                            this.service.GetExportTables(this.WizardState.DataSource.SID).subscribe(tables => {
                                if (tables) {
                                    this.TargetTables = tables;
                                    if (!this.WizardState.TargetTableID && tables && tables.length == 1) {
                                        this.WizardState.TargetTableID = tables[0].SID;
                                    }
                                    if (this.WizardState.TargetTableID) {
                                        this.dmService.GetContainer(this.WizardState.TargetTableID).subscribe(result => {
                                            this.WizardState.TargetTable = result;
                                            if (this.WizardState.structure && this.WizardState.structure.Columns) {
                                                this.WizardState.structure.Columns.forEach((x: any) => {
                                                    if (x.MappedColumn) {
                                                        x.MappedColumn = result.Fields.find((y: any) => y.ID == x.MappedColumn.ID);
                                                    }
                                                });
                                            }
                                            this.checkCanStepForward();
                                            this.cdRef.detectChanges();
                                        });
                                    } else {
                                        this.checkCanStepForward();
                                        this.cdRef.detectChanges();
                                    }
                                }
                            });
                        } else {
                            this.checkCanStepForward();
                            this.cdRef.detectChanges();
                        }
                    }
                });
            } else {
                this.checkCanStepForward();
                this.cdRef.detectChanges();
            }
        });

        const uploadedFile = this.WizardState.UploadedFile;
        if (uploadedFile) {
            let optionString = '';
            if (this.WizardState.FileOptions) {
                optionString = JSON.stringify(this.WizardState.FileOptions);
            }
            if (!this.WizardState.structure || this.WizardState.lastOptions != optionString) {
                this.WizardState.lastOptions = optionString
                // Process a CSV file
                const query = {
                    FileType: this.WizardState.FileType,
                    FileName: uploadedFile.name,
                    Options: optionString
                };
                // Fetch the file structure for the CSV file
                this.service.GetFileStructure(query).subscribe(x => {
                    if (x && x.Columns) {
                        if (this.WizardState.NewTable) {
                            x.Columns.forEach((y: any) => {
                                y.Selected = true;
                                y.MappedColumn = {
                                    ID: UUID.UUID(),
                                    Name: y.Name,
                                    DataTyp: y.DataTyp
                                };
                            });
                        } else {
                            x.Columns.forEach((y: any) => y.Selected = true);
                        }
                    }
                    this.WizardState.structure = x;
                    this.checkCanStepForward();
                    this.cdRef.detectChanges();
                });
            }
            this.FileName = uploadedFile.name;
        } else {
            this.WizardState.structure = null;
        }
    }

    checkCanStepForward(): void {
        let retVal = false;

        if (this.WizardState.DataModel && this.WizardState.DataSource) {
            if (this.WizardState.NewTable) {
                if (this.WizardState.NewTableName) {
                    let anySelected = false;
                    retVal = true;
                    this.WizardState.structure.Columns.some((y: any) => {
                        if (y.Selected) {
                            anySelected = true;
                            if (!y.MappedColumn.Name) {
                                retVal = false;
                                return true;
                            }
                        }
                        return false;
                    });
                    if (!anySelected) {
                        retVal = false;
                    }
                }
            } else if (this.WizardState.TargetTableID) {
                let anySelected = false;
                retVal = true;
                this.WizardState.structure.Columns.some((y: any) => {
                    if (y.Selected) {
                        anySelected = true;
                        if (!y.MappedColumn) {
                            retVal = false;
                            return true;
                        }
                    }
                    return false;
                });
                if (!anySelected) {
                    retVal = false;
                }
            }
        }
        if (retVal != this.CanStepForwardValue) {
            this.CanStepForwardValue = retVal;
            this.cdRef.detectChanges();
        }
    }

    OnWizardStateSet(): void {
        if (this.WizardState && typeof this.WizardState.DoOverwrite != "boolean") {
            this.WizardState.DoOverwrite = true;
        }
    }

    onDataModelChange() {
        this.DataSources = [];
        this.TargetTables = [];
        this.WizardState.DataSource = null;
        this.WizardState.TargetTableID = null;
        this.WizardState.TargetTable = null;
        this.WizardState.TargetTableColumnMap = null;
        if (this.WizardState.structure && this.WizardState.structure.Columns) {
            this.WizardState.structure.Columns.forEach((x: any) => x.MappedColumn = null);
        }
        this.checkCanStepForward();
        const query = new DataSourceQuery(this.WizardState.DataModel.SID);
        query.DBUsages = [[8192]];
        query.IgnoreResourceBase = true;
        this.dmService.GetDataSourcesByQuery(query).subscribe(x => {
            if (x) {
                this.DataSources = x;
            }
        });
    }

    onDataSourceChange() {
        this.TargetTables = [];
        this.WizardState.TargetTableID = null;
        this.WizardState.TargetTable = null;
        this.WizardState.TargetTableColumnMap = null;
        if (this.WizardState.structure && this.WizardState.structure.Columns) {
            this.WizardState.structure.Columns.forEach((x: any) => x.MappedColumn = null);
        }
        this.checkCanStepForward();
        this.service.GetExportTables(this.WizardState.DataSource.SID).subscribe(tables => {
            if (tables) {
                this.TargetTables = tables;
            }
        });
    }

    
    onTableChange() {
        if (this.WizardState.structure && this.WizardState.structure.Columns) {
            this.WizardState.structure.Columns.forEach((x: any) => x.MappedColumn = null);
        }
        if (this.WizardState.TargetTableID) {
            this.dmService.GetContainer(this.WizardState.TargetTableID).subscribe(result => {
                this.WizardState.TargetTable = result;
                if (result && result.Fields) {
                    const map = {};
                    result.Fields.forEach((field: any) => {
                        let list = map[field.DataTyp];
                        if (list) {
                            list.push(field);
                        } else {
                            map[field.DataTyp] = [field];
                        }
                        if (this.WizardState.structure && this.WizardState.structure.Columns) {
                            this.WizardState.structure.Columns.some((col: any) => {
                                if (col.DataTyp == field.DataTyp && col.Name == field.Name) {
                                    col.MappedColumn = field;
                                    return true;
                                }
                                return false;
                            });
                        }
                    });
                    this.WizardState.TargetTableColumnMap = map;
                } else {
                    this.WizardState.TargetTableColumnMap = null;
                }
                this.checkCanStepForward();
                this.cdRef.detectChanges();
            });
        }
    }

    onCreateNew() {
        if (this.WizardState.NewTable) {
            this.WizardState.NewTable = false;
            if (this.WizardState.TargetTableID) {
                this.onTableChange();
            } else {
                this.checkCanStepForward();
            }
        } else {
            this.WizardState.NewTable = true;
            this.WizardState.NewTableName = '';
            this.WizardState.TargetTable = null;
            this.WizardState.TargetTableColumnMap = null;
            if (this.WizardState.UploadedFile) {
                const index = this.WizardState.UploadedFile.name.lastIndexOf('.');
                if (index > -1) {
                    this.WizardState.NewTableName = this.WizardState.UploadedFile.name.substring(0, index);
                } else {
                    this.WizardState.NewTableName = this.WizardState.UploadedFile.name;
                }
            }
            if (this.WizardState.structure && this.WizardState.structure.Columns) {
                this.WizardState.structure.Columns.forEach((x: any) => {
                    x.MappedColumn = {
                        ID: UUID.UUID(),
                        Name: x.Name,
                        DataTyp: x.DataTyp
                    };
                });
            }
            this.checkCanStepForward();
        }
        this.cdRef.detectChanges();
    }

    selectAll(ev: any) {
        if (ev) {
            this.WizardState.structure.Columns.forEach((x: any) => {
                x.Selected = ev.checked;
                this.checkCanStepForward();
            });
        }
    }
}
